// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1cCPZ","title":"BackImages_title__LnR6E","images":"BackImages_images__2sQrx"};